import { useState, useRef, useEffect } from "react"
import { useHistory } from 'react-router-dom';
import { useErrorScreenActions } from '@src/shared/context/error-screen'
import { useTranslation } from "react-i18next";
import { trackErrorScreen, trackErrorScreenCTA } from "@src/pages/Error/tracking/screen";
import { useKeycloakUserState } from "@src/shared/context/keycloak-user";
import i18n from "@src/i18n";
import SSEConsumer from "@src/shared/services/sse-consumer";
import useOnlineStatus from "@src/shared/hooks/use-online-status";
import axios, { AxiosError, AxiosResponse } from 'axios'
import to from 'await-to-js'
import DatadogService from '@shared/services/datadog';
const useSSEErrorHandler = () => {
    const [SSEerror, setSSEerror] = useState(false)
    const [SSERetryActive, setSSERetryActive] = useState(false)
    const SSEerrorRetryCounter = useRef(1)
    const history = useHistory();
    const navigateTo = (route: string) => history.push(`/${route}`);
    const { showErrorScreen, hideErrorScreen } = useErrorScreenActions()
    const { t } = useTranslation();
    const { restaurant } = useKeycloakUserState();
    const [consumer,setConsumer] = useState<null | SSEConsumer>(null)
    const trackingArguments = {
        country: restaurant?.country || '',
        language: i18n.language
    }
    const { isBrowserOnline } = useOnlineStatus()

    const SSERetry = async (withCounter = true) => {
        setSSERetryActive(true)
        setSSEerror(false)
        hideErrorScreen()
        if (withCounter) {
            consumer?.freshReload()
            SSEerrorRetryCounter.current += 1
            trackErrorScreenCTA(trackingArguments)
        }
    }

    useEffect(()=> {    
        if (!isBrowserOnline) {
            hideErrorScreen()
            setSSEerror(false)
            SSEerrorRetryCounter.current = 1
        }

    },[isBrowserOnline])

    const handleSSEError = async (SSEConsumer : SSEConsumer, SSEErrorObject : any) => {
     
  
        const [err, response]  = await to<AxiosResponse, AxiosError>(axios.get(`${SSEConsumer.getConnectionURL()}`))
        
        if (err && err?.response?.status !== 401) {
            return
        }
        setConsumer(SSEConsumer)
        if (SSERetryActive) {
            if (SSEerrorRetryCounter.current <= 2) {
                hideErrorScreen()
                setSSEerror(true)
            }
            else {
                DatadogService.createError(SSEErrorObject, { type: 'SSE Connection Error' });
                setSSEerror(true)
                hideErrorScreen()
                navigateTo('couriers')
                return
            }
        }

        setSSEerror(true)
        trackErrorScreen(trackingArguments)
        showErrorScreen({
            ctaTitle: t('errorscreen.ERROR_SCREEN_CTA_BUTTON_TITLE'),
            title: t('errorscreen.ERROR_SCREEN_TITLE'),
            message: t('errorscreen.ERROR_SCREEN_CONTENT'),
            confirmCallback: () => {
               SSERetry()
            }
        })
    }

    return {
        handleSSEError,
        SSERetry,
        SSEerror,
        SSERetryActive,
        
    }

}

export default useSSEErrorHandler

